import { gql } from '@apollo/client';

export const GET_SCENES = gql`
    query GetScenes {
        getScenes {
            sceneId
            renderers {
                rendererId
                pages {
                    pageId
                    layers {
                        layerId
                        captions {
                            captionId
                            dimension {
                                width
                                height
                            }
                            position {
                                x
                                y
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COMMANDS = gql`
    query myQuery($renderer: String!) {
    getCommands(renderer: $renderer) {
            renderer    
            layer    
            GPI
            DataConnector
            caption {        
                id        
                action        
                option {            
                    id            
                    value        
                }        
                data
            }
    }
}

`;

export const GET_INITIAL_COMMANDS = gql`
    query myQuery ($renderer: String!) {
        getInitialCommands(renderer: $renderer) {
            eventId
            data {
                team {
                    home {
                        tricode
                        kitType
                    }
                    away {
                        tricode
                        kitType
                    }
                }
            }
            renderer
            scenePath
        }
    }
`;

export const GET_PAGE = gql`
query GetScenes($pageId: String!) {
    getPage(pageId: $pageId) {
        sceneId
        renderers {
            rendererId
            pages {
                pageId
                layers {
                    layerId
                    captions {
                        captionId
                        dimension {
                            width
                            height
                        }
                        position {
                            x
                            y
                        }
                    }
                }
            }
        }
    }
}`;